import React, { Component } from 'react';

import { data } from '../../data';

import Modal from './Modal';
import { PlayIconWhite } from '../icons/PlayIconWhite';

import '../../css/components/home-page-banner.scss';

export class HomePageBanner extends Component {
  constructor(props){
    super(props);
    
    // this.toggleVideoModal = this.toggleVideoModal.bind(this);
    // this.resizeModal = this.resizeModal.bind(this);

    // this.state = {
    //   showModal: false,
    //   modalSize: {},
    // }
  }

  // componentDidMount(){
  //   this.resizeModal();
  // }

  // componentDidUpdate(prevProps, prevState){
  //   if(prevProps.viewport.toJS().width !== this.props.viewport.toJS().width || prevProps.viewport.toJS().height !== this.props.viewport.toJS().height){
  //     this.resizeModal();
  //   }
  // }

  // resizeModal(){
  //   console.log('resizing time');
  //   const height = this.props.viewport.toJS().height;

  //   this.setState({
  //     modalSize: { height: height * 0.9},
  //   })
  // }

  toggleVideoModal(){
    // this.setState({
    //   showModal: !this.state.showModal,
    // })
  }

  render(){
    const {
      homePage
    } = data;

    const {
      bannerText,
      bannerVideo,
    } = homePage;



    return (
      <div className="home-page-banner">
        <div className="video-wrapper">
          <video autoPlay muted loop src={ bannerVideo } id="curtisHighlightVideo">
          </video>
        </div>
        
        <div className="banner-text">
          <div className="text">
            { bannerText }
          </div>
        
          <div className="view-highlight-reel" onClick={this.toggleVideoModal}>
            {/* <img src="/public/images/icons/play-icon-white.svg"/> view highlight reel */}
            <PlayIconWhite/>view highlight reel
          </div>
        </div>

        {/* { this.state.showModal &&
          <Modal close={this.toggleVideoModal}>
            <video autoPlay controls src={this.props.bannerImage} id="curtisHighlightVideoModal" style={this.state.modalSize}>
            </video>
          </Modal>
        } */}
        
      </div>
    )
  }
}